import {createStore, compose, applyMiddleware, bindActionCreators} from 'redux';
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import { iReduxState } from '../common/interfaces/interfaces';
import {root_reducer} from './rootReducer';
import thunk from 'redux-thunk';

import * as appActionCreator from './app/appActions';
import * as modalsActionCreator from './modals/modalsActions'

declare global{
	interface Window{
		__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : any;
	}
}

const composeEnhancers = (process.env.REACT_APP_production === 'false' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;
export const store = createStore(root_reducer, composeEnhancers(
    applyMiddleware(thunk)
));

export const useStoreDispatch = () => {
    const dispatch = useDispatch();
    let allActionCreators = {
        ...appActionCreator,
        ...modalsActionCreator
    };
    return bindActionCreators(allActionCreators, dispatch);
}

export type Dispatch = typeof store.dispatch;
export const useStoreSelector: TypedUseSelectorHook<iReduxState> = useSelector;
